/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum Gender {
    MALE = 'male',
    FEMALE = 'female',
}
